export function getAllHSDescription(axiosPrivate, hsDescriptionParams) {
  return axiosPrivate.post('/master-data/hs-description/get-hs-description', hsDescriptionParams)
}

export function getAllPendingHSDescription(axiosPrivate) {
  return axiosPrivate.get('/master-data/hs-description/get-pending-hs-description')
}

export function importDataMapping(axiosPrivate, formData) {
  return axiosPrivate.post('/master-data/hs-description/import-hs-description-mapping', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function exportTemplate(axiosPrivate) {
  return axiosPrivate.get('/master-data/hs-description/export-template-hs-description-list', {
    responseType: 'blob',
  })
}

export function deleteHSDescription(axiosPrivate, payload) {
  return axiosPrivate.post('/master-data/hs-description/delete-hs-description', payload)
}

export function getAllHSVersions(axiosPrivate) {
  return axiosPrivate.get('/master-data/hs-description/get-hs-versions')
}

export function getAllHSDescriptionsLevel(axiosPrivate) {
  return axiosPrivate.get('/master-data/hs-description/get-hs-descriptions-level')
}
